import { dispatch, select } from "@wordpress/data";
import apiFetch from "@wordpress/api-fetch";

import { includes, noop, isEmpty, concat, forEach } from "lodash";

// TODO for updating the backend with edits, also would need to update algolia....
const rootURL = "/wp-json/";
apiFetch.use(apiFetch.createRootURLMiddleware(rootURL));
apiFetch.use(apiFetch.createNonceMiddleware(window.HIFI_APP.rest_nonce));

const saveTrack = ({ id, property, value }) => {
  let data = {};

  console.log("saveTrack");

  let properties = Array.isArray(property) ? property : [property];

  console.log(
    "----------------------------------------------------------------------------"
  );
  console.log("properties");
  console.log(properties);

  properties.forEach((_property) => {
    console.log("--------------------------------");

    console.log("_property");
    console.log(_property);
    console.log("value");
    console.log(value);
    console.log("value[_property]");
    console.log(value[_property]);

    console.log("--------------------------------");
    // single value tax
    if (includes(["artist", "primary-instrument"], _property)) {
      data[`term_${_property}`] = value;
    } else if (includes(["keyword"], _property)) {
      data[`term_${_property}`] = value[_property];
    } else if (includes(["genre.lvl0", "genre.lvl1"], _property)) {
      if (!isEmpty(data.term_genre)) {
        data[`term_genre`] = concat(data[`term_genre`], value[_property]);
      } else {
        data[`term_genre`] = value[_property];
      }
    } else if (includes(_property, "hifi_song_version_title")) {
      data.meta = {};
      data.meta[_property] = value;
    } else if (includes(["shape_name", "bpm", "customizable"], _property)) {
      // bpm is int cast as string
      // customizable is 1/0 cast to bool
      // shape is saved os `shape_name` on algolia but `shape` on WP post meta
      let finalProperty;
      switch (_property) {
        case "shape_name":
          finalProperty = "shape";
          break;
        default:
          finalProperty = _property;
      }

      console.log("finalProperty");
      console.log(finalProperty);

      data.meta = {};
      data.meta[finalProperty] = value;
      // } else if (includes(["title"], _property)) {
      //   // wp fields that need to be prepeneded with post_.
      //   data[`post_${_property}`] = value;
    } else {
      console.log(
        "TODO make sure this is all working properly for all possible values"
      );
      data[_property] = value;
    }
  });

  console.log("data");
  console.log(data);

  // debugger;

  // return;

  return apiFetch({
    path: "/wp/v2/hifi_track/" + id,
    method: "PUT",
    data,
  });
};

export const saveTracks = (tracks, done = noop) => {
  console.log("saveTracks called");
  console.log("tracks");
  console.log(tracks);

  console.time("save tracks");
  const termProperties = ["artist", "genre", "primary-instrument"];
  // return;
  const updatedPostIds = [];
  const promises = [];
  forEach(tracks, (track) => {
    updatedPostIds.push(track.id);
    return promises.push(saveTrack(track));
  });

  Promise.all(promises).then(() => {
    console.timeEnd("save tracks");
    // console.log("all done");

    const { getTracks } = select("hifi");
    const { setTracks } = dispatch("hifi");

    const previousTracks = getTracks();

    // console.log("previousTracks");
    // console.log(previousTracks);

    let updatedTracks = [];
    forEach(previousTracks, (track) => {
      const updatedTrack = {
        ...track,
      };

      if (updatedPostIds.includes(track.objectID)) {
        // console.log("track to update!");
        // console.log(track);
        const trackUpdateData = tracks.find((t) => t.id === track.objectID);
        console.log("trackUpdateData");
        console.log(trackUpdateData);

        let properties = Array.isArray(trackUpdateData.property)
          ? trackUpdateData.property
          : [trackUpdateData.property];

        properties.forEach((_property) => {
          if (termProperties.includes(_property)) {
            // updating a term property
            updatedTrack[_property] = Array.isArray(
              trackUpdateData.algoliaValue
            )
              ? trackUpdateData.algoliaValue
              : [trackUpdateData.algoliaValue];
          } else if (includes(["keyword"], _property)) {
            // updating keyword property
            updatedTrack[_property] = Array.isArray(
              trackUpdateData.algoliaValue[_property]
            )
              ? trackUpdateData.algoliaValue[_property]
              : [trackUpdateData.algoliaValue[_property]];
          } else if (includes(["genre.lvl0", "genre.lvl1"], _property)) {
            updatedTrack[_property] = Array.isArray(
              trackUpdateData.algoliaValue[_property]
            )
              ? trackUpdateData.algoliaValue[_property]
              : [trackUpdateData.algoliaValue[_property]];
          } else if (
            includes(["shape_name", "bpm", "customizable"], _property)
          ) {
            let value = trackUpdateData.algoliaValue;
            let finalValue;
            console.log("_property");
            console.log(_property);
            console.log("value");
            console.log(value);
            switch (_property) {
              case "shape_name":
                // value is string, leave it as-is
                finalValue = value;
                break;
              case "bpm":
                // cast an int to string
                finalValue = value + "";
                break;
              case "customizable":
                // cast 0/1 to bool
                finalValue = !!(1 === parseInt(value));
                break;
            }

            console.log("finalValue");
            console.log(finalValue);

            updatedTrack[_property] = finalValue;
          } else {
            // updating a non-term property
            console.log("TODO, handle this use case!!!!");
            // alert("TODO, handle this use case!!!!");

            updatedTrack[_property] = trackUpdateData.algoliaValue;
          }
        });

        console.log("updatedTrack");
        console.log(updatedTrack);
      }

      updatedTracks.push(updatedTrack);
    });

    setTracks(updatedTracks);

    done();
  });
};
